export default "__VITE_PUBLIC_ASSET__d235e89e__"